import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RESELLER_ADMIN_CREATE_CART_LINK_POPUP } from 'swag-client-common/constants';
import { showPopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { resellerAdminModeSelector } from 'swag-client-common/redux/user/user.selectors';
import { preBuiltCartSave } from 'swag-client-common/redux/cart/cart.actions';
import { ResellerAdminMode, PreBuiltCartAction } from 'swag-common/constants/reseller.constants';
import { getResellerCommission } from '../../../../../../../../redux/reseller-invoice/reseller-invoice.actions';
import { ProceedButtonComponent } from './proceed-button';
const mapStateToProps = createStructuredSelector({
  resellerAdminMode: resellerAdminModeSelector
});
const mapDispatchToProps = dispatch => ({
  onResellerAdminModeBtnClick: resellerAdminMode => {
    if (resellerAdminMode === ResellerAdminMode.CreatingCart) {
      return dispatch(showPopup({
        popup: RESELLER_ADMIN_CREATE_CART_LINK_POPUP
      }));
    }
    dispatch(preBuiltCartSave({
      action: PreBuiltCartAction.Save
    }));
  },
  // TODO MOVE TO PROPPER PLACE ON CHECKOUT
  onCreateInvoiceBtnClick: () => {
    dispatch(getResellerCommission());
  }
});
export const ProceedButton = connect(mapStateToProps, mapDispatchToProps)(ProceedButtonComponent);